import Tracker from '@openreplay/tracker';
import { isProduction } from '@quadminds/shared/utils';
import { useEffect } from 'react';

export const useOpenReplay = (projectKey?: string, userEmail?: string) => {
    useEffect(() => {
        if (!userEmail || !isProduction()) return;
        if (process.env['NX_DISABLE_SESSION_RECORDINGS'] === 'true') return;
        const key = projectKey ?? process.env['NX_OPENREPLAY_KEY'];
        if (!key) {
            console.warn('NX_OPENREPLAY_KEY is not defined');
            return;
        }
        const tracker = new Tracker({
            projectKey: key,
        });

        tracker.start();

        // Tagging the session with user data
        if (userEmail) {
            tracker.setUserID(userEmail);
        }

        // Cleanup on unmount
        return () => {
            tracker.stop();
        };
    }, [projectKey, userEmail]);
};
